import constants from '../screens/PackageBuilder/constants/constants';

const { CONVERSIONS, PRODUCT_CATALOG_SALES } = constants.LAUNCHER;

export const updateUrl = (
  account,
  year,
  month,
  ad,
  campaign,
  preview,
  showAll = null
) => {
  const { origin, pathname } = window.location;
  if (showAll) {
    window.location.replace(
      `${origin}${pathname}#account=${account}&year=${year}&month=${month}&ad=${ad}&campaign=${campaign}&preview=${preview}&showAll=${showAll}`
    );
  } else {
    window.location.replace(
      `${origin}${pathname}#account=${account}&year=${year}&month=${month}&ad=${ad}&campaign=${campaign}&preview=${preview}`
    );
  }
};

export const updateUrlComparerV2 = (urlObj) => {
  const { origin, pathname } = window.location;
  window.location.replace(
    `${origin}${pathname}#account=${urlObj.account}&yearFirst=${
      urlObj.yearFirst
    }&monthFirst=${urlObj.monthFirst}&yearSecond=${
      urlObj.yearSecond
    }&monthSecond=${urlObj.monthSecond}&ad=${urlObj.ad}&campaign=${
      urlObj.campaign
    }&showAll=${urlObj.showAll || 'false'}`
  );
};

export const updateAdLibraryUrl = (urlParameters) => {
  const { origin, pathname } = window.location;
  let urlQueryParams = '';
  const paramKeys = Object.keys(urlParameters);

  paramKeys.forEach((key) => {
    const paramString = `${urlQueryParams === '' ? '#' : '&'}${key}=${
      urlParameters[key]
    }`;
    urlQueryParams += paramString;
  });
  // #oem=${oem}&type=${type}&year=${year}&model-product=${modelOrProduct}&campaign=${campaign}&campaignMonth=${campaignMonth}&package=${packageArg}`
  window.location.replace(`${origin}${pathname}${urlQueryParams}`);
};

export const returnObjectFromUrlQueryParams = () => {
  const url = decodeURIComponent(window.location.href);
  const urlParts = url.split('#');
  const urlQueryParamsObj = {};

  if (!urlParts[1]) {
    return {};
  }

  const params = urlParts[1].split('&');

  params.forEach((paramString) => {
    const paramSplit = paramString.split('=');
    const paramName = paramSplit.length > 0 ? paramSplit[0] : '';
    if (paramName) {
      const paramValue = paramSplit[1] || '';
      urlQueryParamsObj[paramName] = paramValue;
    }
  });

  return urlQueryParamsObj;
};

export const updatePreviewLinkUrl = (
  category = 'model_based',
  index = 0,
  format = 'mobile'
) => {
  const { origin, pathname } = window.location;
  window.location.replace(
    `${origin}${pathname}#category=${category}&index=${index}&format=${format}`
  );
};

export const updatePackageBuilderLaunchUrl = (id) => {
  const { href } = window.location;
  let newUrl = href;
  if (href.includes('#')) {
    newUrl = href.split('#')[0];
  }
  newUrl = id ? `${newUrl}#id=${id}` : newUrl;
  window.location.replace(newUrl);
};

export const returnConversionDomainUrl = ({ destinationUrl, campaign }) => {
  if (
    !campaign ||
    !destinationUrl ||
    ![CONVERSIONS, PRODUCT_CATALOG_SALES].includes(campaign.objective)
  ) {
    return undefined;
  }

  const httpsSplit = destinationUrl.split(/(https?):\/\//);
  const wwwSplit = httpsSplit[httpsSplit.length - 1].split(/www./);

  let conversionDomain = wwwSplit[wwwSplit.length - 1] || '';
  const suffixRegex = /.[a-z0-9]{2,}/gi;

  if (conversionDomain.endsWith('/')) {
    conversionDomain = conversionDomain.substr(0, conversionDomain.length - 1);
  }

  const suffixMatches = conversionDomain.match(suffixRegex);

  if (suffixMatches.length < 2) {
    return conversionDomain;
  }

  conversionDomain = `${suffixMatches[0]}${suffixMatches[1]}`;

  return conversionDomain;
};



// WEBPACK FOOTER //
// ./src/utils/urls.js